const getDisabledChoices = (cars, caps) => ({
  firstChoice:
    cars.filter((car) => car.firstChoice).length >= caps?.firstChoice,
  secondChoice:
    cars.filter((car) => car.secondChoice).length >= caps?.secondChoice,
})

export default getDisabledChoices
